<template>
    <div class="SatisfactionSurvey" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>满意度调研</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="调研名称">
                                    <el-select v-model="queryform.report_id" filterable remote placeholder="请选择" :remote-method="remoteMethod" :loading="loading" @change="changecompany">
                                        <el-option v-for="item in SatisfactionSurveySetData" :key="item.id" :label="item.title" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <!-- <el-button type="primary" @click="AddSatisfactionSurvey">新增</el-button> -->
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 266" :data="tableData" border style="width: 100%">
                    <el-table-column prop="user_name" label="调研人员">
                    </el-table-column>
                    <el-table-column prop="mobile" label="手机号">
                    </el-table-column>
                    <el-table-column prop="company_name" label="调研公司名称">
                    </el-table-column>
                    <el-table-column prop="room" label="室号">
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="Show(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <el-dialog :title="title" :visible.sync="SatisfactionSurvey" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="SatisfactionSurvey">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="名称" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="满意度调研状态">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option label="未发布" :value="0">
                                </el-option>
                                <el-option label="已发布" :value="1">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="调研发布时间" v-if="form.status === 1">
                            <el-date-picker
                                v-model="form.timeSlot"
                                type="datetimerange"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期" align="right">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="SatisfactionSurvey = false">取 消</el-button>
                        <el-button type="primary" @click="SaveSatisfactionSurvey" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog> -->
                <el-drawer
                    :title="title"
                    :visible.sync="drawer"
                    direction="rtl"
                    custom-class="SurveyDetail">
                    <!-- <span>我来啦!</span> -->
                        <p class="title">{{TemplateTitleData.title}}</p>
                        <ul>
                            <li v-for="(item, index) in TemplateDate" :key="item.id">
                                <p class="label" style="color: #000;"><span v-if="item.is_must === 1" style="color: red;">*</span>{{index}}、{{item.title}}</p>
                                <div class="body" v-if="item.type === 1">
                                    <el-radio-group v-model="item.value">
                                        <el-radio :label="items.id" v-for="items in item.options" disabled :key="items.id">{{items.title}}</el-radio>
                                    </el-radio-group>
                                </div>
                                <div class="body" v-if="item.type === 2">
                                    <el-checkbox-group v-model="item.value">
                                        <el-checkbox :label="items.id.toString()" v-for="items in item.options" disabled :key="items.id">{{items.title}}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div class="body" v-if="item.type === 3">
                                    {{item.value}}
                                </div>
                            </li>
                        </ul>
                </el-drawer>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "SatisfactionSurvey",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            SatisfactionSurvey: false,
            form: {
                title: '',
                status: 1,
                timeSlot: []
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                report_id: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            rules: {
                title: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ]
            },
            confirmloding: false,
            SatisfactionSurveySetData: [],
            loading: false,
            drawer: false,
            SurveyDetail: [],
            TemplateDate: {},
            TemplateTitleData: {}
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        AddSatisfactionSurvey () {
            this.SatisfactionSurvey = true
            this.title = '新增公司'
            this.form = {
                title: '',
                status: 1,
                timeSlot: []
            }
            this.fileList = []
        },
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetSatisfactionSurveyList()
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetSatisfactionSurveyList()
        },
        GetSatisfactionSurveyList (keyword, room) {
            let data = {
                report_id: this.queryform.report_id,
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('SatisfactionSurveyListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                this.tableData = res.data
                this.form = {
                    title: '',
                    status: 1,
                    timeSlot: []
                }
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                report_id: ''
            }
        },
        ConfirmQuery() {
            this.currentPage = 1
            this.fullscreenLoading = true
            this.GetSatisfactionSurveyList()
            console.log(this.queryform, this.SatisfactionSurveySetData)
            for (let item in this.SatisfactionSurveySetData) {
                if (this.SatisfactionSurveySetData[item].id === this.queryform.report_id) {
                    this.title = this.SatisfactionSurveySetData[item].title
                }
            }
        },
        SaveSatisfactionSurvey() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.form))
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            data.img = JSON.stringify(this.form.img)
            // this.$refs['ruleForm'].validate((valid) => {
            //     if (valid) {
            //         this.confirmloding = true
            //         that.$store.dispatch('SaveSatisfactionSurvey', data).then(res => {
            //             if (res.flag) {
            //                 that.$message({
            //                     message: res.message,
            //                     type: 'success'
            //                 })
            //                 that.confirmloding = false
            //                 that.SatisfactionSurvey = false
            //                 that.fullscreenLoading = true
            //                 that.GetSatisfactionSurveyList(that.queryform.keyword, that.queryform.room)
            //             } else {
            //                 that.$message({
            //                     message: res.message,
            //                     type: 'warning'
            //                 })
            //             }
            //         })
            //     } else {
            //         return false;
            //     }
            // });
            
        },
        EditSatisfactionSurvey(row) {
            this.SatisfactionSurvey = true
            this.title = '编辑公司'
            this.form = JSON.parse(JSON.stringify(row))
            this.fileList = JSON.parse(this.form.img)
            this.form.img = JSON.parse(this.form.img)
        },
        DelSatisfactionSurvey(row) {
            this.$confirm('是否删除该公司？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelSatisfactionSurvey', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetSatisfactionSurveyList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        },
        remoteMethod (query) {
            if (query !== '') {
                this.loading = true
                let data = {
                    limit: 100,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken(),
                }
                data.keyword = query
                this.$store.dispatch('SatisfactionSurveySetListShow', data).then(res => {
                    this.SatisfactionSurveySetData = res.data
                    this.loading = false
                })
            } else {
                this.loading = true
                let data = {
                    limit: 100,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken(),
                }
                this.$store.dispatch('SatisfactionSurveySetListShow', data).then(res => {
                    this.SatisfactionSurveySetData = res.data
                    this.loading = false
                })
            }
        },
        changecompany (e) {
        },
        GetSatisfactionSurveySetList (keyword, room) {
            let data = {
                limit: 100,
                page: 1,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
            }
            this.$store.dispatch('SatisfactionSurveySetListShow', data).then(res => {
                this.SatisfactionSurveySetData = res.data
            })
        },
        Show (row) {
            let rows = {
                id: row.muban_id
            }
            rows.ADMIN_ID = getAdminId();
            rows.ADMIN_TOKEN = getToken();
            this.$store.dispatch('ShowSurveyTemplateDetail', rows).then(res => {
                if (res.flag) {
                    let data = {
                        id: row.id,
                        ADMIN_ID: getAdminId(),
                        ADMIN_TOKEN: getToken(),
                    }
                    
                    for (let item in res.something) {
                        res.something[item].is_must=Number(res.something[item].is_must)
                        res.something[item].SatisfactionItemDate=res.something[item].options
                        res.something[item].value = ''
                    }
                    this.TemplateTitleData = res.data
                    this.TemplateDate = JSON.parse(JSON.stringify(res.something))
                    this.$store.dispatch('SatisfactionSurveyDetailShow', data).then(res => {
                        for (let item in this.TemplateDate) {
                            for (let items in res.data) {
                                if (this.TemplateDate[item].id === res.data[items].question_id) {
                                    if (this.TemplateDate[item].type === 2) {
                                        this.TemplateDate[item].value = JSON.parse(res.data[items].choose)
                                    } else if (this.TemplateDate[item].type === 1) {
                                        this.TemplateDate[item].value = Number(res.data[items].choose)
                                    } else if (this.TemplateDate[item].type === 3) {
                                        this.TemplateDate[item].value = res.data[items].choose
                                    }
                                }
                            }
                        }
                        this.SurveyDetail = res.data
                        this.drawer = true
                    })
                }
            })
        },
        SatisfactionSurveyTemplate(row) {
            
        },
    },
    created() {
        // this.fullscreenLoading = true
        // this.GetSatisfactionSurveyList()
        this.GetSatisfactionSurveySetList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.SatisfactionSurvey {
    width: 100%;
}
.SatisfactionSurvey .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.SatisfactionSurvey .el-header .el-row .el-col h2 {
    text-align: center;
}
.SatisfactionSurvey .el-header .el-row .el-col {
    text-align: center;
}
.SatisfactionSurvey .el-header .el-row .el-col:last-child {
    text-align: right;
}
.SatisfactionSurvey .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.SatisfactionSurvey .el-main .el-table td {
    height: 40px;
}
.SatisfactionSurvey .el-main .SatisfactionSurvey .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
.SatisfactionSurvey .el-main .SatisfactionSurvey .el-dialog__body .el-form-item {
    display: inline-block;
    width: 50%;
}
.SatisfactionSurvey .el-main .SurveyDetail .el-drawer__body {
    color: #000;
    padding: 0px 20px;
}
.SatisfactionSurvey .el-main .SurveyDetail .el-drawer__body .title {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
}
.SatisfactionSurvey .el-main .SurveyDetail .el-drawer__header {
    margin: 0px;
    font-size: 18px;
    font-weight: 600;
}
.SatisfactionSurvey .el-main .SurveyDetail .el-drawer__body ul li {
    margin-top: 10px;
}
.SatisfactionSurvey .el-main .SurveyDetail .el-drawer__body ul li .body {
    padding-left: 20px;
    margin-top: 5px;
    color: #999;
}
.SatisfactionSurvey .el-main .SurveyDetail .el-drawer__body ul li .body .el-checkbox {
    display: block;
    height: 30px;
    line-height: 30px;
}
.SatisfactionSurvey .el-main .SurveyDetail .el-drawer__body ul li .body .el-radio {
    display: block;
    height: 30px;
    line-height: 30px;
}
</style>
